import { AlertCircle, Mail, Wallet } from 'lucide-react';

import { useCancellationPlan } from 'src/context/billing';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogClose,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import env from 'env';

const UnpaidInvoicesDialog = () => {
  const {
    ui: { step, setInitialData },
  } = useCancellationPlan();

  const onContactUs = () => window.open(`mailto:${env.CODEKEEPER_SERVICE_EMAIL}`, '_blank');

  const onOpenChange = (open: boolean) => {
    if (!open) setInitialData();
  };

  return (
    <Dialog open={step === 'unpaid-invoices'} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[512px] gap-6">
        <div className="flex items-center justify-center size-12 shadow-sm rounded-md bg-card border mx-auto">
          <AlertCircle className="size-6 text-orange-800" />
        </div>
        <DialogHeader className="text-center gap-1.5">
          <DialogTitle>You have unpaid invoices</DialogTitle>
          <DialogDescription>
            There are unpaid invoices connected to your account.
            <br />
            We will not be able to apply changes to your subscription plan until your account has been brought to good
            standing.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex justify-between">
          <Button variant="outline" className="sm:w-1/2" onClick={onContactUs}>
            <Mail />
            Contact us
          </Button>
          <DialogClose asChild>
            <Button className="sm:w-1/2">
              <Wallet />
              Back to billing
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UnpaidInvoicesDialog;
